module.exports = __webpack_public_path__ + "img/UHF-DVS-25.5a5296c1.webp";